/* eslint-disable */

import Vue from 'vue';
import { library, config } from '@fortawesome/fontawesome-svg-core';

config.autoAddCss = false;

import {
    faExclamationTriangle as farExclamationTriangle,
    faMapMarkerAlt as farMapMarkerAlt,
    faQuestionCircle as farQuestionCircle,
    faCog as farCog,
    faArrowLeft as farArrowLeft,
    faTrashAlt as farTrashAlt,
    faSeedling as farSeedling,
    faInfoCircle as farInfoCircle,
    faChevronDown as farChevronDown,
    faChevronUp as farChevronUp,
    faChevronLeft as farChevronLeft,
    faSearch as farSearch,
    faCheck as farCheck,
    faPlus as farPlus,
    faEye as farEye,
    faEyeSlash as farEyeSlash,
    faExternalLink as farExternalLink,
    faEdit as farEdit,
    faCheckSquare as farCheckSquare,
    faSquare as farSquare,
    faCheckCircle as farCheckCircle,
    faHeart as farHeart,
    faShare as farShare,
    faShareAlt as farShareAlt,
    faBell as farBell,
    faUserCircle as farUserCircle,
    faBriefcase as farBriefcase,
    faFileAlt as farFileAlt,
    faSignOut as farSignOut,
    faDotCircle as farDotCircle,
    faCircle as farCircle,
    faPrint as farPrint,
    faEnvelope as farEnvelope,
    faExclamationCircle as farExclamationCircle,
    faAngleRight as farAngleRight,
    faAngleDown as farAngleDown,
    faAngleUp as farAngleUp,
    faDollarSign as farDollarSign,
    faSlidersH as farSlidersH,
    faList as farList,
    faMapMarked as farMapMarked,
    faGripLines as farGripLines,
    faSparkles as farSparkles,
    faArrowRight as farArrowRight,
} from '@fortawesome/pro-regular-svg-icons';

import {
    faChevronDown as fasChevronDown,
    faChevronRight as fasChevronRight,
    faChevronLeft as fasChevronLeft,
    faPlusCircle as fasPlusCircle,
    faInfoCircle as fasInfoCircle,
    faSquare as fasSquare,
    faCheckSquare as fasCheckSquare,
    faHeart as fasHeart,
    faChevronUp as fasChevronUp,
    faCircle as fasCircle,
    faSortUp as fasSortUp,
    faCheckCircle as fasCheckCircle,
    faSave as fasSave,
    faUndo as fasUndo,
    faCaretUp as fasCaretUp,
    faCaretDown as fasCaretDown,
    faArrowRight as fasArrowRight,
    faPhoneAlt as fasPhoneAlt,
    faMapMarkerAlt as fasMapMarkerAlt,
} from '@fortawesome/pro-solid-svg-icons';

import {
    faArrowToBottom as falArrowToBottom,
    faTrashAlt as falTrashAlt,
    faTimes as falTimes,
    faSearch as falSearch,
    faLessThan as falLessThan,
    faCloudUpload as falCloudUpload,
    faEdit as falEdit,
    faPlus as falPlus,
    faAngleDown as falAngleDown,
    faAngleUp as falAngleUp,
    faAngleRight as falAngleRight,
    faMinus as falMinus,
    faLockAlt as falLockAlt,
} from '@fortawesome/pro-light-svg-icons';

import {
    faFacebookSquare,
    faTwitterSquare,
    faLinkedin,
    faSquareXTwitter,
    faXTwitter,
    faSquareFacebook,
} from '@fortawesome/free-brands-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Vue.component('FontAwesomeIcon', FontAwesomeIcon);

library.add(
    falTimes, falTrashAlt, falArrowToBottom, falSearch, falLessThan, falCloudUpload, falEdit, falPlus, falAngleDown, falAngleUp, falAngleRight,
    falMinus, falAngleRight, falLockAlt, farGripLines,

    fasInfoCircle, fasPlusCircle, fasChevronDown, fasChevronRight, fasChevronLeft, fasSquare, fasCheckSquare, fasHeart, fasChevronUp, fasCircle, fasCheckCircle,
    fasHeart, fasCheckSquare, fasSortUp, fasSave, fasUndo, fasCaretUp, fasCaretDown, fasArrowRight, fasPhoneAlt, fasMapMarkerAlt,

    farTrashAlt, farExclamationTriangle, farMapMarkerAlt, farQuestionCircle, farSeedling, farCog, farArrowLeft, farInfoCircle, farSearch, farChevronDown, farChevronUp,
    farCheck, farPlus, farEye, farEyeSlash, farExternalLink, farEdit, farCheckSquare, farSquare, farCheckCircle, farShare, farShareAlt, farBell, farUserCircle,
    farBriefcase, farFileAlt, farSignOut, farDotCircle, farCircle, farPrint, farEnvelope, farExclamationCircle, farAngleRight,
    farHeart, farEnvelope, farAngleRight, farMapMarkerAlt, farSquare, farAngleDown, farAngleUp, farDollarSign,
    farSlidersH, farChevronLeft, farList, farMapMarked, farSparkles, farArrowRight,

    faFacebookSquare, faTwitterSquare, faLinkedin, faSquareXTwitter, faXTwitter, faSquareFacebook,
);
